<template>
    <div>
        <WhatsAppIcon v-if="type === 'whatsapp'"></WhatsAppIcon>
        <TelegramIcon v-else-if="type === 'telegram'"></TelegramIcon>
        <ViberIcon v-else-if="type === 'viber'"></ViberIcon>
        <VKIcon v-else-if="type === 'vk'"></VKIcon>
        <LinkIcon v-else-if="type === 'link'"></LinkIcon>
        <FacebookIcon v-else-if="type === 'facebook'"></FacebookIcon>
        <InstagramIcon v-else-if="type === 'instagram'"></InstagramIcon>
        <ICQIconIcon v-else-if="type === 'icq'"></ICQIconIcon>
    </div>
</template>

<script>
import WhatsAppIcon from "./WhatsAppIcon"
import TelegramIcon from "./TelegramIcon";
import ViberIcon from "./ViberIcon"
import VKIcon from "./VKIcon"
import LinkIcon from "./LinkIcon"
import FacebookIcon from "./FacebookIcon"
import InstagramIcon from "./InstagramIcon"
import ICQIconIcon from "./ICQIcon"

export default {
    components: {
        TelegramIcon,
        WhatsAppIcon,
        ViberIcon,
        VKIcon,
        LinkIcon,
        FacebookIcon,
        InstagramIcon,
        ICQIconIcon,
    },
    props: {
        type: String,
    },
}
</script>
